export default __webpack_public_path__ + "static/media/logo_polygon.97ff139c.svg";